/**
 * ShopLayout - Layout для магазина
 */

import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuthContext, useUserContext } from "../../contexts";
import ShopPayModal from "../shop/ShopPayModal";
import ShopMenu from "../menus/ShopMenu";

const ShopLayout = ({ children }) => {
    const { isAuthenticated, loading } = useAuthContext();
    const { donateBalance, fetchDonateBalance } = useUserContext();
    const navigate = useNavigate();
    const location = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [openBurgerFn, setOpenBurgerFn] = useState(null);

    const handleSetOpenBurger = useCallback((openFn) => {
        setOpenBurgerFn(() => openFn);
    }, []);
    const isFavoritesPage = location.pathname.includes("/ucp/shop/favorites");
    const isBuyPage = location.pathname.includes("/ucp/shop/buy");
    const safeBalance = useMemo(() => donateBalance || 0, [donateBalance]);

    const headerData =
        isBuyPage || isFavoritesPage
            ? { buttonText: "НАЗАД", buttonLink: "/ucp/shop?category=main" }
            : { buttonText: "ЛИЧНЫЙ КАБИНЕТ", buttonLink: "/ucp" };

    useEffect(() => {
        if (loading) return;
        if (!isAuthenticated) {
            navigate("/");
            return;
        }
        fetchDonateBalance();
    }, [isAuthenticated, loading, navigate, fetchDonateBalance]);

    return (
        <div className="app-container app-container--shop">
            <div className="main-container">
                <header className="shop-header">
                    <div className="shop-header-left">
                        <button
                            type="button"
                            className="burger-button shop-burger-button"
                            onClick={() => openBurgerFn && openBurgerFn()}
                            aria-label="Меню"
                        >
                            <div></div>
                        </button>
                        <ShopMenu onTrigger={handleSetOpenBurger} />
                        <div className="logo-container">
                            <Link to="/ucp">
                                <img
                                    src="/media/logo_medieval.png"
                                    alt="Logo"
                                />
                            </Link>
                            <div>
                                <span className="logo-container-title logo-container-title--gold">
                                    Medieval
                                </span>
                                <span className="logo-container-title">
                                    Roleplay
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="shop-header-links">
                        <Link
                            to={headerData.buttonLink}
                            className="shop-header-link shop-header-link--with-back-arrow"
                        >
                            {headerData.buttonText}
                        </Link>
                        <Link
                            to="/ucp/shop/favorites"
                            className={`shop-header-link ${isFavoritesPage ? "active" : ""}`}
                        >
                            ИЗБРАННОЕ
                        </Link>
                    </div>
                    <span className="coin" onClick={() => setIsModalOpen(true)}>
                        {safeBalance}
                        <span>+</span>
                    </span>
                </header>

                <main>{children}</main>
            </div>
            <ShopPayModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </div>
    );
};

export default ShopLayout;
